import React from "react";
import { Link } from "react-router";
import { useState, useEffect } from "react";
import { fetchAllUsStates, fetchCitiesForState } from "@/api/srpFilter";
import { useSelector } from "react-redux";
import { globalCmsData } from "@/redux/cms/cmsSelectors";
import { markInternalNavigation } from "@/utils/attributionCapture";

const SitemapBody = () => {
      const globalCms = useSelector(globalCmsData);

  const sitemap = [
    {
      title: "Hubzu",
      body: [
        { name: "Help", routeLink: "/contact-us" },
        { name: "Home", routeLink: "/" },
      ],
    },
    {
      title: "Company",
      body: [
        { name: "FAQ", routeLink: "/support" },
        { name: "About Us", routeLink: "/about/about-us" },
        { name: "Contact Us", routeLink: "/contact-us" },
      ],
    },
    {
      title: "Legal",
      body: [
        { name: "Your Privacy Rights", routeLink: globalCms?.AltiPrivacy },
        { name: "Terms & Conditions", routeLink: "/about/terms" },
        { name: "Disclaimer", routeLink: "/disclaimer" },
        { name: "Fair Housing and Equal Opportunity", routeLink: globalCms?.FHEO },
      ],
    },
  ];
  const [selectedState, setSelectedState] = useState(null);
  const [statesData, setStatesData] = useState({});
  const [loadingStates, setLoadingStates] = useState(true);
  const [loadingCities, setLoadingCities] = useState(false);

  // Load states on mount
  useEffect(() => {
    const loadStates = async () => {
      try {
        const data = await fetchAllUsStates();
        const formattedStates = {};
        data?.forEach(state => {
          formattedStates[state.name] = { code: state.state.toLowerCase(), cities: [] };
        });
        setStatesData(formattedStates);
      } catch (error) {
        console.error('Error loading states:', error);
      } finally {
        setLoadingStates(false);
      }
    };
    loadStates();
  }, []);

  // Load cities when state is selected
  // Load cities when state is selected
  useEffect(() => {
    if (selectedState && statesData[selectedState]) {
      const loadCities = async () => {
        setLoadingCities(true);
        try {
          const data = await fetchCitiesForState({ state: statesData[selectedState].code });
          setStatesData(prev => ({
            ...prev,
            [selectedState]: {
              ...prev[selectedState],
              cities: data?.map(item => ({
                name: item.city,
                state: item.state,
                citylandingPageUrl: item.citylandingPageUrl
              })) || []
            }
          }));
        } catch (error) {
          console.error('Error loading cities:', error);
        } finally {
          setLoadingCities(false);
        }
      };
      if (statesData[selectedState].cities.length === 0) {
        loadCities();
      } else {

      }
    }
  }, [selectedState]);




  const formatCityName = (cityName) => {
    return cityName.toLowerCase().replace(/[^a-z0-9]/g, '');
  };

  const handleStateClick = (state) => {
    setSelectedState(state);
  };

  const handleBackClick = () => {
    setSelectedState(null);
  };


  return (
    <>
      <div className="container site-map-container my-5">
        <div className="sitemap__featured-section sitemap__grid">
          {sitemap.map((sitemapItem) => {
            return (
              <div className="sitemap__section-header">
                <div className="site-map-title">{sitemapItem.title}</div>
                <ul className="list-unstyled">
                  {sitemapItem?.body.map((sitemapSubItem) => {
                    return (
                      <li className="m-3">
                        <Link
                          className="li-items-sitemap"
                          to={sitemapSubItem?.routeLink}
                        >
                          {sitemapSubItem?.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      <section style={{ backgroundColor: "#f4f7fa" }} >
        <div className="container site-map-container" >
          <div className="container-fluid px-4 py-4">
            <div className="mb-4">
              {selectedState ? (
                <div>
                  <button
                    onClick={handleBackClick}
                    className="btn btn-primary mb-3"
                  >
                    ← Back to States
                  </button>
                  <h1 className="main-title-site-map h2 mb-5">Homes for sale in {selectedState}</h1>
                  <p className="text-muted mb-5">You can either search for homes in popular cities of {selectedState} for Real estate or use the alphabetical directory</p>
                </div>
              ) : (
                <div>
                  <h1 className="h2 main-title-site-map mb-3">Home auctions in all states - Homes for sale</h1>
                  <p className="text-muted mb-2">Hubzu.com is the easiest way to find a new home and save money. Whether you're moving around the block or across the country, we've got you covered.</p>
                  <br></br>
                  <h3 className="mb50 sub-title-site-map">Search for properties in all 50 states, D.C., and Puerto Rico.</h3>
                </div>
              )}
            </div>

            {/* {selectedState ? (
              <div className="row g-3">
                {statesData[selectedState].cities.map((city, index) => (
                  <div key={index} className="col-6 col-md-4 col-lg-3 col-xl-2">
                    <div className="card h-100 border-success">
                      <div className="card-body d-flex align-items-center justify-content-center p-2">
                        <a
                          href={city.citylandingPageUrl}
                          className="text-decoration-none text-dark fw-medium text-center"
                        >
                          {city.name}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="row g-3">
                {Object.keys(statesData).map((name, index) => (
                  <div key={index} className="col-6 col-md-4 col-lg-3 col-xl-2">
                    <div className="card h-100 border-primary">
                      <div className="card-body d-flex align-items-center justify-content-center p-3">
                        <button
                          onClick={() => handleStateClick(name)}
                          className="btn btn-link text-decoration-none p-0 fw-medium text-center"
                        >
                          {name}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )} */}
            {selectedState ? (
              loadingCities ? (
                <div className="">
                  <p>Loading cities...</p>
                </div>
              ) : statesData[selectedState].cities.length > 0 ? (
                <div className="row">
                  {statesData[selectedState].cities.map((city, index) => (
                    <div key={index} className="col-3 mb-2">
                      <a
                        href={city.citylandingPageUrl}
                        className="state-btn text-decoration-none"
                        style={{ color: "#606060", fontSize: '12px', fontFamily: 'graphikregular' }}
                        onClick={() => markInternalNavigation()}
                      >
                        {city.name}
                      </a>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="">
                  <p className="text-muted">Sorry, No Properties Found in {selectedState}</p>
                </div>
              )
            ) : (
              <div className="row">
                {Object.keys(statesData).map((name, index) => (
                  <div key={index} className="col-3 mb-2">
                    <button
                      onClick={() => handleStateClick(name)}
                      className="state-btn btn btn-link text-decoration-none p-0 text-start"
                      style={{ color: "#118bf4", fontSize: '16px', fontFamily: 'graphikregular' }}
                    >
                      {name}
                    </button>
                  </div>
                ))}
              </div>
            )}

          </div>
        </div>
      </section>
    </>
  );
};

export default SitemapBody;
